import { render, staticRenderFns } from "./OfertasOmilView.vue?vue&type=template&id=68b8def2&"
import script from "./OfertasOmilView.vue?vue&type=script&lang=ts&"
export * from "./OfertasOmilView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports